import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import "../../styles/custom.css";
import API_BASE_URL from "../../config";

const Settings = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "Settings | Webyappy";

    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "active") {
          setUser(data.user);
        }
      });
  }, []);

  const hasAccess = (key) =>
    user?.role === "Superadmin" || user?.assigned_microapps?.includes(key);

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3">
          {/* Breadcrumb */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-muted">Settings</span>
              </li>
            </ul>
          </div>

          {/* Settings Cards */}
          <div className="row">
            {/* User Settings Card */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5">
              <div className="card department-microapp-card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="text-dark font-weight-bold mb-3">User</h6>
                  <hr />
                  <ul className="list-unstyled mb-0">
                    {hasAccess("settings_add_user") && (
                      <li className="mb-2">
                        <Link
                          to="/pages/settings/AddUser"
                          className="microapp-link"
                        >
                          Add User
                        </Link>
                      </li>
                    )}

                    {hasAccess("settings_view_user") && (
                      <li className="mb-2">
                        <Link to="/pages/settings/ViewUser" className="microapp-link">
                          View/Edit Users
                        </Link>
                      </li>
                    )}

                    {hasAccess("settings_assign_microapp") && (
                      <li className="mb-2">
                        <Link
                          to="/pages/settings/AssignMicroapp"
                          className="microapp-link"
                        >
                          Assign Microapp
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            {/* Invoice Settings Card */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5">
              <div className="card department-microapp-card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="text-dark font-weight-bold mb-3">Invoice Settings</h6>
                  <hr />
                  <ul className="list-unstyled mb-0">
                    {hasAccess("settings_billing_address") && (
                      <li className="mb-2">
                        <Link
                          to="/pages/settings/BillingAddress"
                          className="microapp-link"
                        >
                          Billing Address
                        </Link>
                      </li>
                    )}
                    {hasAccess("settings_manage_brands") && (
                      <li className="mb-2">
                        <Link
                          to="/pages/settings/ManageBrands"
                          className="microapp-link"
                        >
                          Manage Brands
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
